import { Box, type BoxProps } from "@tokenterminal/ui/Box"
import { containerCss } from "./Container.css"

const Container = ({ className, ...props }: BoxProps) => {
  return <Box className={[containerCss, className]} {...props} />
}

export default Container
